import React, { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
// import { Link } from "react-router-dom";

const Dashboard = () => {
  const [menu, setMenu] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={(value) => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="p-8">
            <div className="p-2">
              <h1 className="text-2xl text-black">Dashboard</h1>
              <span className="text-red-600">Admin & User Side. (Will change as per roles)</span>
            </div>
            {/* Row 1 */}
            <div className="flex flex-wrap">
              {/* col-xl-7 */}
              <div className="col-xl-7 lg:w-3/5 p-2">
                {/* card */}
                <div className="card flex-grow">
                  <div className="p-3 border-b-2">
                    <div className="justify-between items-center">
                      <h5 className="text-lg text-black">Active Users</h5> 
                    </div>
                  </div>
                  <div className="relative p-6">
                    <div className="flex flex-wrap items-center mb-4">
                      <div>
                        <span>Company</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                      <div>
                        <span>Branch</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                      <div>
                        <span>User</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                    </div>
                    <div id="sales_chart"></div>
                  </div>
                </div>
              </div>
              {/* col-xl-5 */}
              <div className="col-xl-5 lg:w-2/5 p-2">
                <div className="card flex-grow h-full">
                  <div className="p-3 border-b-2">
                    <div className="justify-between items-center">
                      <h5 className="text-lg text-black">Users</h5>
                    </div>
                  </div>
                  <div className="relative p-6">
                    <div className="flex flex-wrap items-center mb-4">
                      <div>
                        <span>Company</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                      <div>
                        <span>Branch</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                      <div>
                        <span>User</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                    </div>
                    <div id="sales_chart"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* Row 2 */}
            <div className="flex flex-wrap">
              {/* col-xl-7 */}
              <div className="col-xl-7 lg:w-1/2 p-2">
                {/* card */}
                <div className="card flex-grow">
                  <div className="p-3 border-b-2">
                    <div className="justify-between items-center">
                      <h5 className="text-lg text-black">Company and Branch</h5>
                    </div>
                  </div>
                  <div className="relative p-6">
                    <div className="flex flex-wrap items-center mb-4">
                      <div>
                        <span>Company</span>
                        <p className="mr-12 text-sky-600 text-xl">2000</p>
                      </div>
                      <div>
                        <span>Branch</span>
                        <p className="mr-12 text-sky-600 text-xl">2000</p>
                      </div>
                      <div>
                        <span>User</span>
                        <p className="mr-12 text-sky-600 text-xl">2000</p>
                      </div>
                    </div>
                    <div id="sales_chart"></div>
                  </div>
                </div>
              </div>
              {/* col-xl-5 */}
              <div className="col-xl-5 lg:w-1/2 p-2">
                <div className="card flex-grow h-full">
                  <div className="p-3 border-b-2">
                    <div className="justify-between items-center">
                      <h5 className="text-lg text-black">System Analytics</h5>
                    </div>
                  </div>
                  <div className="relative p-6">
                    <div className="flex flex-wrap items-center mb-4">
                      <div>
                        <span>Company</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                      <div>
                        <span>Branch</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                      <div>
                        <span>User</span>
                        <p className="mr-12 text-sky-600 text-xl">1000</p>
                      </div>
                    </div>
                    <div id="sales_chart"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
